import type {PublicMethodUtils} from '@wix/document-services-types'
import type {GlobalComponentsPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<GlobalComponentsPublicAPI> {
    const {
        extensionPublicAPI: {getter, dataManipulation}
    } = publicMethodUtils

    return {
        methods: {
            global: {
                components: {
                    add: dataManipulation('globalComponents.add', {
                        getReturnValueMethodPath: 'globalComponents.getGlobalComponentToAddRef'
                    }),
                    remove: dataManipulation('globalComponents.remove'),
                    getReferringComponents: getter('globalComponents.getReferringComponents')
                }
            }
        }
    }
}
